module.exports = __webpack_public_path__ + "img/simbolos_violeta2.26deed49.jpeg";